// extracted by mini-css-extract-plugin
export var container = "_8w-0";
export var error = "_8w-9";
export var label = "_8w-5";
export var light = "_8w-6";
export var md = "_8w-3";
export var sm = "_8w-2";
export var thin = "_8w-8";
export var thinBold = "_8w-7";
export var vertical = "_8w-4";
export var xs = "_8w-1";